import { Component, EventEmitter, NgModule, OnInit, Output, ViewChild } from '@angular/core';
import { DxTreeViewModule, DxTreeViewComponent } from 'devextreme-angular/ui/tree-view';

import { SharedModule } from '../../modules/shared/shared.module';
// import DataSource from 'devextreme/data/data_source';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
// import { genericCustomStoreService } from '../../services/genericCustomStore.service';
// import { DxTreeListComponent } from 'devextreme-angular';
// import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { slideToggleAnimation } from 'src/app/core/menue.anmations';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss'],
  animations: [slideToggleAnimation],
})
export class SideNavigationMenuComponent implements OnInit {
  // @ViewChild(DxTreeListComponent, { static: true }) dxtree: DxTreeListComponent
  // LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  // currentLang: any;
  // menu!: DxTreeViewComponent;
  // data: any
  // lists: any = []
  // sessiondata: any = null
  // selectedIndex: number
  // expendarray: number[] = []
  // tabs: any = []
  // isnewtab: boolean
  // settingdata: any = {}
  // focusedRowKey: number;
  // constructor(public router: Router, public genericCustomStoreService: genericCustomStoreService, public publicSettingService: publicSettingService) {
  // this.currentLang = localStorage.getItem(
  //   this.LOCALIZATION_LOCAL_STORAGE_KEY
  // );
  // this.genericCustomStoreService.checkIsNewTab().subscribe((result: boolean) => {
  //   this.isnewtab = result;
  // });


  // if (window.sessionStorage.getItem('data') != null) {
  //   this.sessiondata = sessionStorage.getItem("data");
  //   this.data = JSON.parse(this.sessiondata).navihationMenu;

  //   this.data.forEach((element: any) => {
  //     if (element.externalUrl.includes('tab')) {
  //       element.tabs = []
  //       this.data.forEach((ele: any) => {
  //         console.log('inside', ele)
  //         if (ele.parentId == element.id) {
  //           element.tabs.push(ele)
  //           this.data = this.data.filter((ele: { parentId: number }) => {
  //             return ele.parentId != element.id
  //           })
  //         }
  //       })
  //       this.tabs.push(element.tabs)
  //     }
  //     this.genericCustomStoreService.sessiondata.next(this.tabs)
  //   });

  //   this.data.sort((a: { displayOrder: any, externalUrl: string }, b: { displayOrder: any, externalUrl: string }) => a.displayOrder - b.displayOrder);
  //   this.lists = new DataSource({
  //     store: this.data,
  //   });

  // }
  // else {
  //   this.router.navigate(['/login-form'])
  // }


  // if (localStorage.getItem('activePath') != null) {
  //   let path = localStorage.getItem('activePath')
  //   let ele = this.data.filter((res: { externalUrl: string }, id: number) => {
  //     return res.externalUrl == path

  //   })
  //   this.focusedRowKey = ele[0]?.id
  // }
  // }

  // onFocusedRowChanged(e: any) {
  //   if (e?.row) {
  //     this.expandrows(e.row?.node)
  //     this.dxtree.instance.forEachNode((node: any) => {
  //       this.expendarray.includes(node.key) ? this.dxtree.instance.expandRow(node.key) : this.dxtree.instance.collapseRow(node.key);
  //       return;
  //     });


  //     if (e.row.node.children.length > 0) {
  //       return
  //     }
  //     //to navigate to routing
  //     if (e.row?.data?.externalUrl == 'tab') {
  //       e.row.data.tabs.sort((a: { displayOrder: any, externalUrl: string }, b: { displayOrder: any, externalUrl: string }) => parseFloat(a.displayOrder) - parseFloat(b.displayOrder));
  //       this.router.navigate([e.row.data.tabs[0].externalUrl])

  //     }
  //     else if (e.row?.data?.externalUrl != "" || e.row?.data?.externalUrl != 'undefined') {
  //       const targetRoute = e.row.data.externalUrl;

  //       // Construct the full URL
  //       const baseUrl = window.location.origin; // Get base URL (e.g., http://localhost:4200)
  //       const fullUrl = `${baseUrl}/#/${targetRoute}`; // Combine base URL with route

  //       if (this.isnewtab == true) {
  //         // Open the route in a new tab
  //         window.open(fullUrl, '_blank');
  //       } else {
  //         this.router.navigate([e.row?.data?.externalUrl])
  //       }

  //       // this.router.navigate([e.row?.data?.externalUrl])
  //     }

  //     this.expendarray = []

  //   }

  // }

  // expandrows(data: any) {
  //   this.expendarray.push(data?.key)
  //   if (data?.level > 0) {
  //     this.expandrows(data?.parent)
  //   }
  // }


  //_______________________________________________________________________glopal Varibels_________________________________________________________________________//

  @Output() closeMenueFn = new EventEmitter<boolean>(true)
  rootMenus: any[] = [];
  expanded: { [key: number]: boolean } = {};


  textLanguage: any
  data: any
  activeItemId: number | null = null;
  //_______________________________________________________________________glopal Varibels_________________________________________________________________________//







  //_______________________________________________________________________Life Cycle Hook_________________________________________________________________________//
  logoUrl: string = "assets/icons/ERPh.png";
  ngOnInit(): void {
    if(environment.apiRoot.includes("cdcbak")) {
              this.logoUrl = "assets/icons/cdcLogo.png"
            }

    this.getDataFromLocalStorage()
    this.getTranslation()
  }
  //_______________________________________________________________________Life Cycle Hook_________________________________________________________________________//

  closeMenue() {
    this.closeMenueFn.emit(true)
  }


  getDataFromLocalStorage() {
    
    let session = sessionStorage.getItem('data');    
    if (session) {
      let parseData = JSON.parse(session);
      const root = parseData.navihationMenu.find((x: any) => x.parentId == null);
      this.data = parseData
      this.rootMenus = this.buildTree(root.id, parseData.navihationMenu);
    }
  }



  buildTree(parentId: number, items: any[]): any[] {
    const result = items
      .filter(item => item.parentId === parentId)
      .map(item => ({
        ...item,
        children: this.buildTree(item.id, items)
      }));
    return result;
  }


  toggle(id: number, event: Event) {
    event.stopPropagation();
    this.expanded[id] = !this.expanded[id];
  }

  getTranslation() {
    let currentLang = localStorage.getItem('Language');
    this.textLanguage = currentLang == 'ar' ? 'nameAr' : 'nameEn'
  }

  Search(event: any) {
    
    let value = event.target.value?.toLowerCase();
    let parent = this.data.navihationMenu.find((x: any) => x.parentId == null)
    if (!value) {
      this.rootMenus = this.buildTree(parent.id, this.data.navihationMenu);
      this.expanded = {};
      return;
    }
    const matches: any[] = [];
    const getParents = (item: any, allItems: any[]) => {
      let result: any[] = [];
      let parent = allItems.find(x => x.id === item.parentId);
      while (parent) {
        result.push(parent);
        parent = allItems.find(x => x.id === parent.parentId);
      }
      return result;
    };

    this.data.navihationMenu.forEach((ele: any) => {
      let nameAr = ele.nameAr?.toLowerCase() || '';
      let nameEn = ele.nameEn?.toLowerCase() || '';
      if (nameAr.includes(value) || nameEn.includes(value)) {
        matches.push(ele, ...getParents(ele, this.data.navihationMenu));
      }
    });

    const unique = Array.from(new Map(matches.map(item => [item.id, item])).values());
    var rootparent = this.data.navihationMenu.find((x: any) => x.parentId == null).id;
    this.rootMenus = this.buildTree(rootparent, unique);
    unique.forEach(item => this.expanded[item.parentId] = true);
  }


  setActive(id: number) {
    this.activeItemId = id;
  }
}


@NgModule({
  imports: [DxTreeViewModule, SharedModule, RouterModule, CommonModule,
    BrowserModule],
  declarations: [SideNavigationMenuComponent],
  exports: [SideNavigationMenuComponent]
})
export class SideNavigationMenuModule { }
